<template>
    <main>
        <div class="row">
            <div class="col-12">
                <div class="tile">
                    <div class="form-inline">
                        <client-select v-if="!clientId" class="mr-1 mb-2" :model="filterFormModel" attribute="client" @change="search"
                            :isFilter="true" :place-holder="$t('selectClient')"></client-select>
                        <form-select :model="filterFormModel" attribute="type" class="mr-1 mb-2" :options="[
                            { value: null, text: this.$t('chooseType') },
                            { value: 'aichat', text: $t('aichat') },
                            { value: 'autoreply', text: this.$t('autoReply') },
                        ]"></form-select>
                        <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-2" :options="[
                            { value: null, text: $t('status') },
                            { value: 'sending', text: $t('notYetSent') },
                            { value: 'success', text: $t('success') },
                            { value: 'fail', text: $t('error') }
                        ]"></form-select>
                        <time-range-picker :model="filterFormModel" :label="$t('time')" class="mr-1 mb-2"
                            :defaultShortcut="3"></time-range-picker>
                        <button @click="load" class="btn btn-primary mr-1 mb-2">{{ $t('search') }}</button>
                        <button @click="reset" class="btn btn-secondary mr-1 mb-2">{{ $t('reset') }}</button>
                        <history-export
                            v-if="['owner', 'admin', 'tech', 'operationsManager', 'account'].includes($store.state.user.role)"
                            :filter="filterFormModel" :total-count="itemCount" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="c-paging clearfix">
                    <div class="c-paging__count" v-if="itemCount > 0">
                        {{ $t('found', [itemCount]) }}
                    </div>
                    <div class="c-paging__right">
                        <div class="c-paging__numbers">
                            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                                v-model="filterFormModel.page" :total-rows="itemCount"
                                :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12" v-if="items.length > 0">
                <div class="c-smart-table tile">
                    <div class="row c-smart-table__title">
                        <div class="col-lg-2">{{ $t('client') }}</div>
                        <div class="col-lg-2">Bot</div>
                        <div class="col-lg-2">{{ $t('account') }}</div>
                        <div class="col-lg-3">{{ $t('content') }}</div>
                        <div class="col-lg-3">{{ $t('info') }}</div>
                    </div>
                    <div class="row" v-for="item in items" :key="item._id">
                        <div class="col-lg-2">
                          <span><b>{{ $t('name') }}: </b> {{ item.client.companyName }}</span>
                          <span><b>Domain: </b>{{ item.client.domain }}</span>
                        </div>
                        <div class="col-lg-2">
                            <p v-if="item.bot">
                                {{ item.bot.name }}
                            </p>
                            <p>
                                <span class="badge" :class="item.type === 'autoreply' ? 'badge-info' : 'badge-primary'">
                                    {{ item.type === 'aichat' ? $t('aichat') : $t('autoReply') }}</span>
                            </p>
                        </div>
                        <div class="col-lg-2">
                            <div v-if="item.account">
                                {{ `${item.account.type}: ${item.account.name}` }}
                            </div>
                            <div v-else>
                                {{ $t("unknown") }}
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <p v-if="item.message">
                                <b>{{ $t('question') }}: </b>
                                <span>{{ item.message.content }}</span>
                            </p>
                            <p v-if="item.reply">
                                <b>{{ $t('theAnswer') }}: </b>
                                <span>{{ item.reply.content }}</span>
                            </p>
                        </div>
                        <div class="col-lg-3">
                            <p>
                                <b>{{ $t('createTime') }}:&nbsp;</b>
                                <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                            </p>
                            <p v-if="item.sendTime">
                                <b>{{ $t('sendTime') }}:&nbsp;</b>
                                <span>{{ item.sendTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
                            </p>
                            <p>
                                <b>{{ $t('status') }}: </b>
                                <label class="badge badge-warning" v-if="!item.sendTime">{{ $t('notYetSent') }}</label>
                                <label class="badge badge-success" v-if="item.sendTime && !item.error">{{ $t('sent')
                                    }}</label>
                                <label class="badge badge-danger" v-if="item.sendTime && item.error">{{ $t('sentFail')
                                    }}</label>
                            </p>
                            <p v-if="item.errorMsg">
                                <b>{{ $t('error') }}: </b>
                                <span class="text-danger">{{ item.errorMsg }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center text-danger" v-if="items.length === 0 && !loading">{{
                            $t('notFoundSearch')
                        }}
            </div>
            <div class="col-12" v-if="itemCount > 0">
                <div class="c-paging clearfix">
                    <div class="c-paging__count" v-if="itemCount">
                        {{ $t('found', [itemCount]) }}
                    </div>
                    <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                        v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                        @input="load">
                    </b-pagination>

                </div>
            </div>
        </div>
    </main>
</template>

<script>
import list from '@/mixins/List';
import utils from '@/utils';
import ClientSelect from "@/components/ClientSelect";
import TimeRangePicker from "@/components/TimeRangePicker";
import HistoryExport from "./HistoryExport";
import moment from 'moment';
import _ from 'lodash';

export default {
    components: { TimeRangePicker, ClientSelect, HistoryExport },
    mixins: [list, utils],
    props: {
        clientId: String,
    },
    data() {
        return {
            service: '/chat-auto-reply',
            autoLoad: true,
            defaultFilterFormModel: {
                client: this.clientId || null,
                type: null,
                status: null,
                from: moment().subtract('29', 'day').startOf('day').valueOf(),
                to: moment().endOf('day').valueOf(),
            }
        }
    },
    methods: {
        search: _.debounce(function () {
            this.filterFormModel.page = 1;
            this.load();
        }, 200),
    },
    i18n: {
        messages: {
            en: {
                from: 'Sent from',
                toID: 'Sent to Facebook ID',
                time: 'Time',
                content: 'Content',
                createTime: 'Create time',
                sendTime: 'Send time',
                notYetSent: 'Not yet sent',
                messageCampaigns: "Message campaigns",
                messageTemplate: "template",
                seeTemplate: "See templates",
                smsType: 'Type',
                reset: 'Reset',
                message: "Message {0}",
                sent: "Sent",
                notFoundSearch: "No results found!",
                sentFail: "Sent failed",
                status: "Status",
                chooseType: "Choose type",
                chatBot: "Chatbot",
                autoReply: "Auto reply",
                question: "Question",
                theAnswer: "Answer",
                account: "Account",
                customer: "Customer",
                error: "Error",
                unknown: "Unknown",
                aichat: "AI chat",
            },
            vi: {
                from: 'Gửi từ',
                toID: 'Gửi tới Facebook ID',
                time: 'Thời gian',
                content: 'Nội dung',
                createTime: 'Tạo lúc',
                sendTime: 'Gửi lúc',
                messageTemplate: "Mẫu tin nhắn",
                messageCampaigns: "Chiến dịch gửi tin nhắn",
                seeTemplate: "Xem mẫu",
                notYetSent: 'Chưa gửi',
                smsType: 'Loại',
                reset: 'Đặt lại',
                message: "Tin nhắn {0}",
                sent: "Đã gửi",
                notFoundSearch: "Không tìm thấy kết quả nào!",
                sentFail: "Gửi thất bại",
                status: "Tình trạng",
                chooseType: "Chọn loại",
                chatBot: "Chatbot",
                autoReply: "Trả lời tự động",
                question: "Câu hỏi",
                theAnswer: "Câu trả lời",
                account: "Tài khoản",
                customer: "Khách hàng",
                error: "Có lỗi",
                unknown: "Chưa rõ",
                aichat: "Nhân viên AI",
            }
        }
    },
}
</script>